import React, { Component } from "react";
import { FormattedMessage } from "react-intl";
import { handleError } from "services/errorService";
import { Notification } from "./../Notification/Notification";

const ErrorNotification = ({
  children,
  errorState,
  message = (
    <FormattedMessage
      id="Error.Application"
      defaultMessage="An unexpected error has occurred, please contact us if you continue to have problems."
    />
  )
}) => {
  if (errorState.error) {
    //Some error was thrown. Let's display something to the user
    return (
      <Notification error>
        <b>{message}</b>
      </Notification>
    );
  }

  return children;
};

export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: false,
      info: null,
      history: []
    };
  }

  componentDidCatch(error, info) {
    // Something happened to one of my poor children, add to state and have a breakdown
    this.setError(error, info);
  }

  componentDidUpdate(prevProps, prevState) {
    this.logError(prevState);
  }

  setError = (error, info) => {
    // Something happened to one of my poor children.
    // Add error to state and have a breakdown
    this.setState({
      error: error,
      info: info,
      history: this.state.history.concat({ error: this.state.error, info: this.state.info })
    });
  };

  logError = prevState => {
    const { error, info, history } = this.state;
    const isNewError = history.length ? history.length > prevState.history.length : !!error;
    if (isNewError) handleError(error, info);
  };

  render() {
    return (
      <ErrorNotification errorState={this.state} {...this.props}>
        {this.props.children}
      </ErrorNotification>
    );
  }
}
